import anime from "animejs";

const initLinks = () => {
  const lis = document.querySelectorAll(".page-template-page-carrefourcollection .content_links li");

  const onMouseEnter = (e) => {
    const activeLink = document.querySelector(".page-template-page-carrefourcollection .content_links li.active");
    const activeImage = document.querySelector(".page-template-page-carrefourcollection .content_imgs li.active");

    const id = e.target.dataset["id"];
    const targetLiImage = document.querySelector(
      '.page-template-page-carrefourcollection .content_imgs li[data-id="' + id + '"]'
    );

    const isArchive = id === "0";

    activeLink && activeLink.classList.remove("active");
    !isArchive && activeImage.classList.remove("active");

    e.target.classList.add("active");
    !isArchive && targetLiImage.classList.add("active");
  };

  lis.forEach((li) => {
    li.addEventListener("mouseenter", onMouseEnter);
  });

  initLinkAnims();
};

const initLinkAnims = () => {
  // anime({
  //   targets: ".page-template-page-carrefourcollection .content_links li.active .arrow-link",
  //   translateX: [0, 50],
  //   loop: true,
  //   direction: "alternate",
  //   duration: 400,
  //   autoplay: true,
  // });
};

const initPageCarrefourCollection = () => {
  initLinks();
  // initLinkAnims();
};

export default initPageCarrefourCollection;
